// extracted by mini-css-extract-plugin
module.exports = {"container":"IconText_container___oRBL","icon":"IconText_icon__O03nl"};